/* ===================================================
   SALINITY - Main JavaScript (Shopify 2.0 Theme)
   Custom smooth scroll + GSAP ScrollTrigger animations
   AJAX Cart Drawer, Product Page, FAQ Accordion
   =================================================== */

(function () {
  'use strict';

  // ====== CUSTOM SMOOTH SCROLL (ScrollSmoother-like) ======
  const wrapper = document.getElementById('smooth-wrapper');
  const content = document.getElementById('smooth-content');

  let scrollY = 0;
  let currentY = 0;
  const ease = 0.1;
  let rafId = null;
  let isMobile = window.innerWidth < 768;

  function initSmoothScroll() {
    if (!wrapper || !content) return;

    if (isMobile) {
      wrapper.style.position = 'static';
      wrapper.style.overflow = 'visible';
      wrapper.style.height = 'auto';
      content.style.transform = 'none';
      return;
    }

    document.body.style.height = content.scrollHeight + 'px';
    wrapper.style.position = 'fixed';
    wrapper.style.top = '0';
    wrapper.style.left = '0';
    wrapper.style.width = '100%';
    wrapper.style.height = '100%';
    wrapper.style.overflow = 'hidden';

    smoothLoop();
  }

  function smoothLoop() {
    if (!content) return;

    scrollY = window.scrollY;
    currentY += (scrollY - currentY) * ease;

    const roundedY = Math.round(currentY * 100) / 100;
    content.style.transform = `translate3d(0, ${-roundedY}px, 0)`;

    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.update();
    }
    rafId = requestAnimationFrame(smoothLoop);
  }

  function updateContentHeight() {
    if (!content) return;
    if (isMobile) return;
    document.body.style.height = content.scrollHeight + 'px';
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      isMobile = window.innerWidth < 768;
      if (isMobile && rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
        if (wrapper) {
          wrapper.style.position = 'static';
          wrapper.style.overflow = 'visible';
          wrapper.style.height = 'auto';
        }
        if (content) {
          content.style.transform = 'none';
        }
        document.body.style.height = '';
      } else if (!isMobile && !rafId) {
        initSmoothScroll();
      } else {
        updateContentHeight();
      }
    }, 200);
  });

  // ====== GSAP SETUP ======
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
  }

  initSmoothScroll();

  window.addEventListener('load', () => {
    updateContentHeight();
    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.refresh();
    }
  });

  // ====== HEADER SCROLL BEHAVIOR ======
  const header = document.getElementById('siteHeader');

  if (header && typeof ScrollTrigger !== 'undefined') {
    const announcementHeight = 36;

    ScrollTrigger.create({
      start: 1,
      end: 'max',
      onUpdate: (self) => {
        const sy = self.scroll();

        if (sy > 50) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }

        if (sy > announcementHeight) {
          header.classList.add('hide-announcement');
        } else {
          header.classList.remove('hide-announcement');
        }
      },
    });
  }

  // ====== MEGA MENU ======
  const navLinks = document.querySelectorAll('.nav-link[data-mega]');
  const megaMenus = document.querySelectorAll('.mega-menu');
  let megaTimeout;

  function closeMegaMenus() {
    megaMenus.forEach((m) => m.classList.remove('active'));
    navLinks.forEach((l) => l.classList.remove('active'));
  }

  navLinks.forEach((link) => {
    const megaId = 'mega-' + link.dataset.mega;
    const megaMenu = document.getElementById(megaId);

    link.addEventListener('mouseenter', () => {
      clearTimeout(megaTimeout);
      closeMegaMenus();
      if (megaMenu) {
        megaMenu.classList.add('active');
        link.classList.add('active');
      }
    });

    link.addEventListener('mouseleave', () => {
      megaTimeout = setTimeout(closeMegaMenus, 200);
    });

    if (megaMenu) {
      megaMenu.addEventListener('mouseenter', () => {
        clearTimeout(megaTimeout);
      });
      megaMenu.addEventListener('mouseleave', () => {
        megaTimeout = setTimeout(closeMegaMenus, 150);
      });
    }
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.mega-menu') && !e.target.closest('.nav-link')) {
      closeMegaMenus();
    }
  });

  // ====== SEARCH OVERLAY ======
  const searchToggle = document.getElementById('searchToggle');
  const searchOverlay = document.getElementById('searchOverlay');
  const searchClose = document.getElementById('searchClose');
  const searchInput = document.getElementById('searchInput');

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', () => {
      searchOverlay.classList.add('active');
      if (searchInput) setTimeout(() => searchInput.focus(), 300);
    });
  }
  if (searchClose && searchOverlay) {
    searchClose.addEventListener('click', () => {
      searchOverlay.classList.remove('active');
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (searchOverlay) searchOverlay.classList.remove('active');
      closeMobileMenu();
    }
  });

  // ====== MOBILE MENU ======
  const mobileMenuToggle = document.getElementById('mobileMenuToggle');
  const mobileMenu = document.getElementById('mobileMenu');
  const mobileMenuClose = document.getElementById('mobileMenuClose');
  const mobileMenuOverlay = document.getElementById('mobileMenuOverlay');
  const mobileExpandables = document.querySelectorAll('.mobile-nav-expandable');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('active');
    if (mobileMenuOverlay) mobileMenuOverlay.classList.add('active');
    if (mobileMenuToggle) mobileMenuToggle.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('active');
    if (mobileMenuOverlay) mobileMenuOverlay.classList.remove('active');
    if (mobileMenuToggle) mobileMenuToggle.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (mobileMenuToggle) mobileMenuToggle.addEventListener('click', openMobileMenu);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileMenu);
  if (mobileMenuOverlay) mobileMenuOverlay.addEventListener('click', closeMobileMenu);

  mobileExpandables.forEach((btn) => {
    btn.addEventListener('click', () => {
      const submenu = btn.nextElementSibling;
      const isActive = btn.classList.contains('active');
      mobileExpandables.forEach((b) => {
        b.classList.remove('active');
        if (b.nextElementSibling) b.nextElementSibling.classList.remove('active');
      });
      if (!isActive) {
        btn.classList.add('active');
        if (submenu) submenu.classList.add('active');
      }
    });
  });

  // ====== CAROUSEL ENGINE ======
  class Carousel {
    constructor(trackEl, options = {}) {
      this.track = trackEl;
      this.cards = Array.from(trackEl.children);
      this.currentIndex = 0;
      this.isDragging = false;
      this.startX = 0;
      this.currentTranslate = 0;
      this.prevTranslate = 0;
      this.cardWidth = 0;
      this.gap = options.gap || 20;
      this.cardsVisible = options.cardsVisible || 3;
      this.dotsContainer = options.dotsContainer || null;
      this.autoplay = options.autoplay || false;
      this.autoplayInterval = options.autoplayInterval || 5000;
      this.autoplayTimer = null;
      this.init();
    }

    init() {
      this.calcDimensions();
      this.setupDrag();
      this.setupDots();
      if (this.autoplay) this.startAutoplay();
      window.addEventListener('resize', () => {
        this.calcDimensions();
        this.goTo(this.currentIndex, false);
        this.setupDots();
      });
    }

    calcDimensions() {
      if (this.cards.length === 0) return;
      const card = this.cards[0];
      const rect = card.getBoundingClientRect();
      this.cardWidth = rect.width + this.gap;
      const trackParent = this.track.parentElement;
      const parentWidth = trackParent.getBoundingClientRect().width;
      this.cardsVisible = Math.max(1, Math.floor(parentWidth / this.cardWidth));
    }

    get maxIndex() {
      return Math.max(0, this.cards.length - this.cardsVisible);
    }

    setupDrag() {
      this.track.addEventListener('touchstart', (e) => this.dragStart(e), { passive: true });
      this.track.addEventListener('touchmove', (e) => this.dragMove(e), { passive: false });
      this.track.addEventListener('touchend', () => this.dragEnd());
      this.track.addEventListener('mousedown', (e) => this.dragStart(e));
      this.track.addEventListener('mousemove', (e) => this.dragMove(e));
      this.track.addEventListener('mouseup', () => this.dragEnd());
      this.track.addEventListener('mouseleave', () => {
        if (this.isDragging) this.dragEnd();
      });
      this.track.querySelectorAll('a, img').forEach((el) => {
        el.addEventListener('dragstart', (e) => e.preventDefault());
      });
    }

    dragStart(e) {
      this.isDragging = true;
      this.startX = this.getPositionX(e);
      this.prevTranslate = this.currentTranslate;
      this.track.style.transition = 'none';
      if (this.autoplay) this.stopAutoplay();
    }

    dragMove(e) {
      if (!this.isDragging) return;
      const currentX = this.getPositionX(e);
      const diff = currentX - this.startX;
      this.currentTranslate = this.prevTranslate + diff;
      this.track.style.transform = `translateX(${this.currentTranslate}px)`;
    }

    dragEnd() {
      this.isDragging = false;
      this.track.style.transition = '';
      const movedBy = this.currentTranslate - this.prevTranslate;
      if (movedBy < -50 && this.currentIndex < this.maxIndex) {
        this.currentIndex++;
      } else if (movedBy > 50 && this.currentIndex > 0) {
        this.currentIndex--;
      }
      this.goTo(this.currentIndex);
      if (this.autoplay) this.startAutoplay();
    }

    getPositionX(e) {
      return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
    }

    goTo(index, animate = true) {
      this.currentIndex = Math.max(0, Math.min(index, this.maxIndex));
      this.currentTranslate = -this.currentIndex * this.cardWidth;
      if (!animate) this.track.style.transition = 'none';
      this.track.style.transform = `translateX(${this.currentTranslate}px)`;
      if (!animate) {
        this.track.offsetHeight;
        this.track.style.transition = '';
      }
      this.updateDots();
    }

    prev() { this.goTo(this.currentIndex - 1); }

    next() {
      if (this.currentIndex >= this.maxIndex) {
        this.goTo(0);
      } else {
        this.goTo(this.currentIndex + 1);
      }
    }

    setupDots() {
      if (!this.dotsContainer) return;
      this.dotsContainer.innerHTML = '';
      const totalDots = this.maxIndex + 1;
      for (let i = 0; i < totalDots; i++) {
        const dot = document.createElement('button');
        dot.className = 'carousel-dot' + (i === this.currentIndex ? ' active' : '');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => this.goTo(i));
        this.dotsContainer.appendChild(dot);
      }
    }

    updateDots() {
      if (!this.dotsContainer) return;
      const dots = this.dotsContainer.querySelectorAll('.carousel-dot');
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === this.currentIndex);
      });
    }

    startAutoplay() {
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => this.next(), this.autoplayInterval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  // Initialize testimonials carousel
  const testimonialsTrack = document.getElementById('testimonialsTrack');
  const testimonialDots = document.getElementById('testimonialDots');
  if (testimonialsTrack) {
    const testimonialsCarousel = new Carousel(testimonialsTrack, {
      gap: 20,
      dotsContainer: testimonialDots,
      autoplay: true,
      autoplayInterval: 6000,
    });
    document.querySelectorAll('[data-carousel="testimonials"]').forEach((btn) => {
      if (btn.classList.contains('carousel-prev')) {
        btn.addEventListener('click', () => testimonialsCarousel.prev());
      } else {
        btn.addEventListener('click', () => testimonialsCarousel.next());
      }
    });
  }

  // ====== GSAP SCROLL ANIMATIONS ======
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {

    // Hero entrance animation
    const heroBadge = document.querySelector('.hero-badge');
    if (heroBadge) {
      const heroTl = gsap.timeline({ delay: 0.3 });
      const heroLines = document.querySelectorAll('.hero-line');
      const heroSubtitle = document.querySelector('.hero-subtitle');
      const heroActions = document.querySelector('.hero-actions');
      const heroStats = document.querySelector('.hero-stats');
      const heroScroll = document.querySelector('.hero-scroll-indicator');

      heroTl.from(heroBadge, { opacity: 0, y: 30, duration: 0.8, ease: 'power3.out' });
      if (heroLines.length) heroTl.from(heroLines, { opacity: 0, y: 60, duration: 0.9, stagger: 0.15, ease: 'power3.out' }, '-=0.4');
      if (heroSubtitle) heroTl.from(heroSubtitle, { opacity: 0, y: 30, duration: 0.7, ease: 'power3.out' }, '-=0.5');
      if (heroActions) heroTl.from(heroActions, { opacity: 0, y: 20, duration: 0.6, ease: 'power3.out' }, '-=0.3');
      if (heroStats) heroTl.from(heroStats, { opacity: 0, y: 20, duration: 0.6, ease: 'power3.out' }, '-=0.2');
      if (heroScroll) heroTl.from(heroScroll, { opacity: 0, duration: 0.5, ease: 'power2.out' }, '-=0.1');

      // Counter animation — fires right after stats fade in
      const heroStatNumbers = document.querySelectorAll('.hero-stat-number');
      heroStatNumbers.forEach((num) => {
        const target = parseInt(num.dataset.count, 10);
        if (!target || target === 0) {
          num.textContent = '0';
          return;
        }
        heroTl.to(num, {
          textContent: target,
          duration: 1,
          ease: 'power2.out',
          snap: { textContent: 1 },
        }, '-=0.5');
      });
    }

    // Section headers reveal
    const sectionHeaders = document.querySelectorAll('.section-header');
    if (sectionHeaders.length) {
      sectionHeaders.forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
          },
          opacity: 0,
          y: 40,
          duration: 0.7,
          ease: 'power3.out',
        });
      });
    }

    // Split section content reveal
    const splitSection = document.querySelector('.split-section');
    if (splitSection) {
      const splitContentChildren = splitSection.querySelectorAll('.split-content > *');
      if (splitContentChildren.length) {
        gsap.from(splitContentChildren, {
          scrollTrigger: {
            trigger: splitSection,
            start: 'top 70%',
          },
          opacity: 0,
          y: 30,
          duration: 0.6,
          stagger: 0.1,
          ease: 'power3.out',
        });
      }

      // Split left side parallax zoom
      const splitTarget = splitSection.querySelector('.split-product-img') || splitSection.querySelector('.split-bg');
      if (splitTarget) {
        gsap.fromTo(
          splitTarget,
          { scale: 1.1 },
          {
            scale: 1,
            scrollTrigger: {
              trigger: splitSection,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 1,
            },
            ease: 'none',
          }
        );
      }
    }

    // Pack cards reveal
    const packCards = document.querySelectorAll('.pack-card');
    if (packCards.length) {
      gsap.from(packCards, {
        scrollTrigger: {
          trigger: packCards[0].parentElement,
          start: 'top 80%',
        },
        opacity: 0,
        y: 60,
        duration: 0.8,
        stagger: 0.12,
        ease: 'power3.out',
      });
    }

    // Parallax background movement
    const parallaxBreak = document.querySelector('.parallax-break');
    if (parallaxBreak) {
      const parallaxBg = parallaxBreak.querySelector('.parallax-bg');
      if (parallaxBg) {
        gsap.to(parallaxBg, {
          scrollTrigger: {
            trigger: parallaxBreak,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
          },
          y: -100,
          ease: 'none',
        });
      }

      const parallaxSubtitle = parallaxBreak.querySelector('.parallax-subtitle');
      if (parallaxSubtitle) {
        gsap.fromTo(parallaxSubtitle, {
          opacity: 0,
          y: 30,
        }, {
          opacity: 1,
          y: 0,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: parallaxBreak,
            start: 'top 55%',
            end: 'top 30%',
            scrub: 1,
          },
        });
      }

      const parallaxTitle = parallaxBreak.querySelector('.parallax-title');
      if (parallaxTitle) {
        gsap.fromTo(parallaxTitle, {
          opacity: 0,
          scale: 0.8,
        }, {
          opacity: 1,
          scale: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: parallaxBreak,
            start: 'top 45%',
            end: 'top 20%',
            scrub: 1,
          },
        });
      }
    }

    // Ingredients grid reveal
    const ingredientsGrid = document.querySelector('.ingredients-grid');
    if (ingredientsGrid) {
      const ingredientCards = ingredientsGrid.querySelectorAll('.ingredient-card');
      if (ingredientCards.length) {
        gsap.from(ingredientCards, {
          scrollTrigger: {
            trigger: ingredientsGrid,
            start: 'top 80%',
          },
          opacity: 0,
          y: 30,
          scale: 0.95,
          duration: 0.5,
          stagger: 0.04,
          ease: 'power3.out',
        });
      }
    }

    // Ingredients images parallax
    const ingredientsSection = document.querySelector('.ingredients-section-v2');
    const imgLeft = document.querySelector('.ingredients-img-left');
    const imgRight = document.querySelector('.ingredients-img-right');

    if (ingredientsSection && imgLeft && window.innerWidth > 768) {
      gsap.set(imgLeft, { willChange: 'transform' });
      gsap.fromTo(imgLeft, { y: -30 }, {
        scrollTrigger: {
          trigger: ingredientsSection,
          start: 'top 80%',
          end: 'center top',
          scrub: 1.5,
        },
        y: 30,
        ease: 'power1.out',
      });
    }

    if (ingredientsSection && imgRight && window.innerWidth > 768) {
      gsap.set(imgRight, { willChange: 'transform' });
      gsap.fromTo(imgRight, { y: 60 }, {
        scrollTrigger: {
          trigger: ingredientsSection,
          start: 'top 80%',
          end: 'center top',
          scrub: 1.5,
        },
        y: -80,
        ease: 'power1.out',
      });
    }

    // Testimonials reveal
    if (testimonialsTrack) {
      const testimonialCards = document.querySelectorAll('.testimonial-card');
      if (testimonialCards.length) {
        gsap.from(testimonialCards, {
          scrollTrigger: {
            trigger: testimonialsTrack,
            start: 'top 80%',
          },
          opacity: 0,
          y: 40,
          duration: 0.6,
          stagger: 0.1,
          ease: 'power3.out',
        });
      }
    }

    // Benefits reveal
    const benefitsGrid = document.querySelector('.benefits-grid');
    if (benefitsGrid) {
      const benefitItems = benefitsGrid.querySelectorAll('.benefit-item');
      if (benefitItems.length) {
        gsap.from(benefitItems, {
          scrollTrigger: {
            trigger: benefitsGrid,
            start: 'top 85%',
          },
          opacity: 0,
          x: -30,
          duration: 0.6,
          stagger: 0.1,
          ease: 'power3.out',
        });
      }
    }

    // CTA section reveal
    const ctaSection = document.querySelector('.cta-section');
    if (ctaSection) {
      const ctaContent = ctaSection.querySelectorAll('.cta-content > *');
      if (ctaContent.length) {
        gsap.from(ctaContent, {
          scrollTrigger: {
            trigger: ctaSection,
            start: 'top 70%',
          },
          opacity: 0,
          y: 40,
          duration: 0.7,
          stagger: 0.1,
          ease: 'power3.out',
        });
      }
    }

    // Social grid reveal
    const socialGrid = document.querySelector('.social-grid');
    if (socialGrid) {
      const socialCards = socialGrid.querySelectorAll('.social-card');
      if (socialCards.length) {
        gsap.from(socialCards, {
          scrollTrigger: {
            trigger: socialGrid,
            start: 'top 85%',
          },
          opacity: 0,
          scale: 0.9,
          duration: 0.5,
          stagger: 0.08,
          ease: 'power3.out',
        });
      }
    }

    // Footer reveal
    const siteFooter = document.querySelector('.site-footer');
    if (siteFooter) {
      const footerCols = siteFooter.querySelectorAll('.footer-col');
      if (footerCols.length) {
        gsap.from(footerCols, {
          scrollTrigger: {
            trigger: siteFooter,
            start: 'top 85%',
          },
          opacity: 0,
          y: 30,
          duration: 0.6,
          stagger: 0.08,
          ease: 'power3.out',
        });
      }
    }

  } // end GSAP animations guard

  // ====== NEWSLETTER FORM ======
  const newsletterForm = document.getElementById('newsletterForm');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = newsletterForm.querySelector('.cta-input');
      if (input && input.value.trim()) {
        input.value = '';
        const btn = newsletterForm.querySelector('.btn');
        if (btn) {
          const originalText = btn.textContent;
          btn.textContent = 'Subscribed!';
          btn.style.background = '#315367';
          btn.style.borderColor = '#315367';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.style.background = '';
            btn.style.borderColor = '';
          }, 2500);
        }
      }
    });
  }

  // ====== SMOOTH SCROLL FOR ANCHOR LINKS ======
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const target = link.getAttribute('href');
      if (target && target !== '#') {
        const el = document.querySelector(target);
        if (el) {
          e.preventDefault();
          closeMobileMenu();
          const elTop = el.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top: elTop, behavior: 'smooth' });
        }
      }
    });
  });

  // ====== CART DRAWER (AJAX) ======
  const CartDrawer = {
    drawer: null,
    overlay: null,
    itemsContainer: null,
    subtotalEl: null,
    countEls: null,
    emptyState: null,
    filledState: null,

    init() {
      this.drawer = document.getElementById('cartDrawer');
      this.overlay = document.getElementById('cartDrawerOverlay');
      if (!this.drawer) return;

      this.itemsContainer = this.drawer.querySelector('.cart-drawer-items');
      this.subtotalEl = this.drawer.querySelector('.cart-drawer-subtotal');
      this.countEls = document.querySelectorAll('.cart-count');
      this.emptyState = this.drawer.querySelector('.cart-drawer-empty');
      this.filledState = this.drawer.querySelector('.cart-drawer-filled');

      // Close handlers
      const closeBtn = this.drawer.querySelector('.cart-drawer-close');
      if (closeBtn) closeBtn.addEventListener('click', () => this.close());
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());

      // Open handlers
      document.querySelectorAll('[data-cart-toggle]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      // Delegate quantity/remove clicks inside drawer
      if (this.itemsContainer) {
        this.itemsContainer.addEventListener('click', (e) => {
          const removeBtn = e.target.closest('[data-remove-key]');
          if (removeBtn) {
            this.updateItem(removeBtn.dataset.removeKey, 0);
            return;
          }
          const minusBtn = e.target.closest('[data-qty-minus]');
          if (minusBtn) {
            const key = minusBtn.dataset.qtyMinus;
            const currentQty = parseInt(minusBtn.closest('.cart-drawer-item').querySelector('.cart-drawer-qty-value').textContent, 10);
            this.updateItem(key, Math.max(0, currentQty - 1));
            return;
          }
          const plusBtn = e.target.closest('[data-qty-plus]');
          if (plusBtn) {
            const key = plusBtn.dataset.qtyPlus;
            const currentQty = parseInt(plusBtn.closest('.cart-drawer-item').querySelector('.cart-drawer-qty-value').textContent, 10);
            this.updateItem(key, currentQty + 1);
          }
        });
      }

      // Initial cart fetch
      this.fetchCart();
    },

    open() {
      if (!this.drawer) return;
      this.drawer.classList.add('active');
      if (this.overlay) this.overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('cart-drawer-open');
      this.fetchCart();
    },

    close() {
      if (!this.drawer) return;
      this.drawer.classList.remove('active');
      if (this.overlay) this.overlay.classList.remove('active');
      document.body.style.overflow = '';
      document.body.classList.remove('cart-drawer-open');
    },

    async fetchCart() {
      try {
        const res = await fetch(window.Shopify.routes.cart_url + '.js');
        const cart = await res.json();
        this.render(cart);
      } catch (err) {
        console.error('Cart fetch error:', err);
      }
    },

    async addToCart(variantId, quantity = 1) {
      try {
        const res = await fetch(window.Shopify.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        });
        await res.json();
        this.open();
      } catch (err) {
        console.error('Add to cart error:', err);
      }
    },

    async updateItem(key, quantity) {
      try {
        const res = await fetch(window.Shopify.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        const cart = await res.json();
        this.render(cart);
      } catch (err) {
        console.error('Cart update error:', err);
      }
    },

    render(cart) {
      this.updateCount(cart.item_count);

      if (cart.item_count === 0) {
        if (this.emptyState) this.emptyState.style.display = '';
        if (this.filledState) this.filledState.style.display = 'none';
        return;
      }

      if (this.emptyState) this.emptyState.style.display = 'none';
      if (this.filledState) this.filledState.style.display = '';

      if (this.itemsContainer) {
        this.itemsContainer.innerHTML = cart.items.map(item => `
          <div class="cart-drawer-item">
            <div class="cart-drawer-item-img">
              ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
            </div>
            <div class="cart-drawer-item-info">
              <h4>${item.product_title}</h4>
              ${item.variant_title ? `<p class="drawer-item-variant">${item.variant_title}</p>` : ''}
              <p class="drawer-item-price">${this.formatMoney(item.final_line_price)}</p>
              <div class="cart-drawer-qty">
                <button class="quantity-btn" data-qty-minus="${item.key}">\u2212</button>
                <span class="cart-drawer-qty-value">${item.quantity}</span>
                <button class="quantity-btn" data-qty-plus="${item.key}">+</button>
                <a href="#" class="cart-item-remove" data-remove-key="${item.key}">Remove</a>
              </div>
            </div>
          </div>
        `).join('');
      }

      if (this.subtotalEl) {
        this.subtotalEl.textContent = this.formatMoney(cart.total_price);
      }
    },

    updateCount(count) {
      if (this.countEls) {
        this.countEls.forEach(el => { el.textContent = count; });
      }
    },

    formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  CartDrawer.init();

  // ====== PRODUCT PAGE ======
  const ProductPage = {
    init() {
      const productForm = document.getElementById('productForm');
      if (!productForm) return;

      // Thumbnail gallery
      const mainImage = document.getElementById('productMainImage');
      const thumbs = document.querySelectorAll('.pdp-thumb');
      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          thumbs.forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
          if (mainImage) {
            mainImage.src = thumb.dataset.imageUrl || thumb.querySelector('img').src;
          }
        });
      });

      // Variant selector — uses productVariantsJson to match options to variants
      const variantBtns = productForm.querySelectorAll('.pdp-option-btn');
      const variantInput = productForm.querySelector('input[name="id"]');
      const priceEl = document.querySelector('.pdp-price-current');
      const comparePriceEl = document.querySelector('.pdp-price-compare');
      const addToCartBtn = productForm.querySelector('.pdp-add-btn');

      // Parse variant data from the JSON script block
      let variants = [];
      const variantsJson = document.getElementById('productVariantsJson');
      if (variantsJson) {
        try { variants = JSON.parse(variantsJson.textContent); } catch (e) { /* ignore */ }
      }

      // Track selected options (e.g., { 1: "Citrus", 2: "Large" })
      const selectedOptions = {};
      variantBtns.forEach(btn => {
        if (btn.classList.contains('active')) {
          selectedOptions[btn.dataset.optionPosition] = btn.dataset.value;
        }
      });

      function findMatchingVariant() {
        return variants.find(v => {
          return Object.keys(selectedOptions).every(pos => {
            return v['option' + pos] === selectedOptions[pos];
          });
        });
      }

      function updateVariantUI(variant) {
        if (!variant) return;
        if (variantInput) variantInput.value = variant.id;
        if (priceEl) priceEl.textContent = CartDrawer.formatMoney(variant.price);
        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = CartDrawer.formatMoney(variant.compare_at_price);
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
        if (addToCartBtn) {
          if (variant.available) {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = 'Add to Cart';
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = 'Sold Out';
          }
        }
        if (variant.featured_image && mainImage) {
          mainImage.src = variant.featured_image.src;
          const matchingThumb = document.querySelector(`.pdp-thumb[data-image-id="${variant.featured_image.id}"]`);
          if (matchingThumb) {
            thumbs.forEach(t => t.classList.remove('active'));
            matchingThumb.classList.add('active');
          }
        }
      }

      variantBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          // Deselect siblings in the same option group
          const position = btn.dataset.optionPosition;
          productForm.querySelectorAll(`.pdp-option-btn[data-option-position="${position}"]`).forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          selectedOptions[position] = btn.dataset.value;
          const variant = findMatchingVariant();
          if (variant) updateVariantUI(variant);
        });
      });

      // Quantity +/-
      const qtyMinus = productForm.querySelector('.quantity-minus');
      const qtyPlus = productForm.querySelector('.quantity-plus');
      const qtyInput = productForm.querySelector('.pdp-qty-input');
      if (qtyMinus && qtyInput) {
        qtyMinus.addEventListener('click', () => {
          const val = parseInt(qtyInput.value, 10);
          if (val > 1) qtyInput.value = val - 1;
        });
      }
      if (qtyPlus && qtyInput) {
        qtyPlus.addEventListener('click', () => {
          qtyInput.value = parseInt(qtyInput.value, 10) + 1;
        });
      }

      // Add to cart form submit -> AJAX -> open cart drawer
      productForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const id = variantInput ? variantInput.value : productForm.querySelector('[name="id"]').value;
        const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        const addBtn = productForm.querySelector('.pdp-add-btn');
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Adding...';
        }
        await CartDrawer.addToCart(id, qty);
        if (addBtn) {
          addBtn.textContent = 'Added!';
          setTimeout(() => {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
          }, 1500);
        }
      });
    }
  };

  ProductPage.init();

  // ====== FAQ ACCORDION ======
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    if (question) {
      question.addEventListener('click', () => {
        const isActive = item.classList.contains('active');
        faqItems.forEach(i => i.classList.remove('active'));
        if (!isActive) item.classList.add('active');
      });
    }
  });


  // ====== COLLECTION CARD ADD TO CART ======
  document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      await CartDrawer.addToCart(variantId, 1);
      btn.textContent = 'Added!';
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      }, 1500);
    });
  });

  // ====== PRODUCT QUICKVIEW MODAL ======
  const quickviewOverlay = document.getElementById('quickviewOverlay');
  const quickviewModal = document.getElementById('quickviewModal');
  const quickviewClose = document.getElementById('quickviewClose');
  const quickviewImage = document.getElementById('quickviewImage');
  const quickviewTitle = document.getElementById('quickviewTitle');
  const quickviewPrice = document.getElementById('quickviewPrice');
  const quickviewDescription = document.getElementById('quickviewDescription');
  const quickviewAddBtn = document.getElementById('quickviewAddBtn');
  const quickviewFullLink = document.getElementById('quickviewFullLink');
  const quickviewQtyInput = document.getElementById('quickviewQtyInput');
  const quickviewQtyMinus = document.getElementById('quickviewQtyMinus');
  const quickviewQtyPlus = document.getElementById('quickviewQtyPlus');

  let quickviewVariantId = null;

  function openQuickview(handle) {
    fetch('/products/' + handle + '.js')
      .then(res => res.json())
      .then(product => {
        quickviewImage.src = product.featured_image ? product.featured_image.replace(/(\.[^.]+)$/, '_800x$1') : '';
        quickviewImage.alt = product.title;
        quickviewTitle.textContent = product.title;
        quickviewPrice.textContent = '$' + (product.price / 100).toFixed(2);
        quickviewDescription.innerHTML = product.description ? product.description.substring(0, 400) + (product.description.length > 400 ? '...' : '') : '';
        quickviewFullLink.href = '/products/' + handle;
        quickviewVariantId = product.variants[0].id;
        quickviewQtyInput.value = 1;

        quickviewOverlay.classList.add('active');
        quickviewModal.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
  }

  function closeQuickview() {
    quickviewOverlay.classList.add('closing');
    quickviewModal.classList.add('closing');
    setTimeout(() => {
      quickviewOverlay.classList.remove('active', 'closing');
      quickviewModal.classList.remove('active', 'closing');
      quickviewOverlay.style.opacity = '';
      quickviewModal.style.opacity = '';
      document.body.style.overflow = '';
    }, 300);
  }

  if (quickviewClose) quickviewClose.addEventListener('click', closeQuickview);
  if (quickviewOverlay) quickviewOverlay.addEventListener('click', closeQuickview);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && quickviewModal && quickviewModal.classList.contains('active')) closeQuickview();
  });

  if (quickviewQtyMinus && quickviewQtyInput) {
    quickviewQtyMinus.addEventListener('click', () => {
      const val = parseInt(quickviewQtyInput.value, 10);
      if (val > 1) quickviewQtyInput.value = val - 1;
    });
  }
  if (quickviewQtyPlus && quickviewQtyInput) {
    quickviewQtyPlus.addEventListener('click', () => {
      quickviewQtyInput.value = parseInt(quickviewQtyInput.value, 10) + 1;
    });
  }

  if (quickviewAddBtn) {
    quickviewAddBtn.addEventListener('click', async () => {
      if (!quickviewVariantId) return;
      quickviewAddBtn.disabled = true;
      quickviewAddBtn.textContent = 'Adding...';
      const qty = parseInt(quickviewQtyInput.value, 10) || 1;
      await CartDrawer.addToCart(quickviewVariantId, qty);
      quickviewAddBtn.textContent = 'Added!';
      setTimeout(() => {
        quickviewAddBtn.disabled = false;
        quickviewAddBtn.textContent = 'Add to Cart';
        closeQuickview();
      }, 1000);
    });
  }

  document.querySelectorAll('.card-quick-view-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.dataset.productHandle;
      if (handle) openQuickview(handle);
    });
  });

  // ====== SCROLL-TRIGGERED VIDEO PLAYBACK ======
  const splitVideo = document.getElementById('splitVideo');
  if (splitVideo) {
    let wasInView = false;

    // Start hidden, fade in when playing
    splitVideo.style.opacity = '0';
    splitVideo.style.transition = 'opacity 1.2s ease';

    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !wasInView) {
          wasInView = true;
          splitVideo.currentTime = 0;
          splitVideo.playbackRate = 0.7;
          splitVideo.style.opacity = '1';
          splitVideo.play();
        } else if (!entry.isIntersecting && wasInView) {
          wasInView = false;
          splitVideo.style.opacity = '0';
        }
      });
    }, { threshold: 0.6 });

    videoObserver.observe(splitVideo);
  }

})();
